var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center mb-20 mx-auto rounded-full h-60 w-60 bg-sky-100"},[_c('Headset',{staticClass:"h-35 w-35 text-sky-500"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }